<script>
  import {onMount} from 'svelte'
  import {getCards} from '~/Library/api'
  import store from '~/Library/store'
 
  import Layout from '~/Components/Layout/Layout'
  import CardOrganism from '~/Components/Organisms/CardCollection'
  import CardTypes from '~/Data/Data.json'

  export let type = 'personal'

  const content = CardTypes
  let data = {
    cardSize: content[type].cardSize, 
    cards: []
  }

  onMount(() => {
    window.scrollTo(0, 0)

    getCards(type).then((rsp) => {
      data.cards = rsp.data[content[type].graphQlType]
      store.setAttribute('card_type', type)
      store.setAttribute('data', data)
    }).catch((err) => false)
  })
</script>

<Layout>

  <img class="cards__background" src="/static/shapes/rectangle.svg" alt="">

  <section class="cards">

    <h1 class="heading">{content[type].title}</h1>

    <blockquote>

      <img class="cards__quote cards__quote-top" src="/static/shapes/quote.svg" alt="">

      <p>{content[type].content}</p>

      <img class="cards__quote cards__quote-bottom" src="/static/shapes/quote.svg" alt="">
      
    </blockquote>

  </section>

  {#if data.cards.length > 0}

    <CardOrganism {...data} /> 

  {/if}

</Layout>

<style lang="scss">
  .cards {
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center; 
    padding: 4rem 0;
    blockquote {
      position: relative;
      flex-basis: 60%;
      line-height: 150%;
      text-align: right;
    }
    &__background {
      height: 50rem;
      width: 50rem;
      position: absolute;
      top: -300px; 
      left: -270px;
      transform: rotateZ(50deg);
      z-index: -10;
    }
    &__quote {  
      position: absolute;
      &-top {
        top: -40px;
        left: 0;
      }
      &-bottom {
        right: 0;
        bottom: -20px;
        -moz-transform: scale(-1, -1);
        -o-transform: scale(-1, -1);
        -webkit-transform: scale(-1, -1);
        transform: scale(-1, -1);
      }
    }

    @media only screen and (max-width: 576px) {
      flex-direction: column;
      align-items: flex-start;
      margin: 3rem 0 1rem 0;
      padding: unset;
      h1.heading {
        margin-bottom: 2.5rem;
      }
      blockquote {
        margin: 1rem 0;
        text-align: left;
      }
      &__background {
        left: -580px;
        top: -400px;
      }
    }
  }
</style>